// extracted by mini-css-extract-plugin
export default {"container":"Partnerships_container__seouz","header":"Partnerships_header__fS6+v"};